function windowResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    setFont();
  }, 100);
}

function setFont() {
  let device = getDevide();
  if (device === 'pc') {
    let height = $(document).height();
    let width = (height * 750) / 1435;
    $('body').css('max-width', width + 'px');
    let fontsize = (width * 100) / 750;
    $('html').css('font-size', fontsize + 'px');
  } else if (device === 'phone') {
    $('html').css('font-size', 'calc(100vw / 750 * 100)');
  }
}

// 设备类型
function getDevide() {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) ? 'phone' : 'pc';
}

// 提示
function showtip(text) {
  $('.warn_box').html(text);
  $('.warn_wrapper').fadeIn(0, function () {
    setTimeout(() => {
      $('.warn_wrapper').fadeOut(100, () => {
        $('.warn_box').html('');
      });
    }, 500);
  });
}

function toQueryString(params) {
  // 输出: page=1&limit=10
  return Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
}
function detectDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /mobile|android|iphone|ipad|ipod/i.test(userAgent);
  let deviceType = 'pc';

  if (isMobile) {
    if (/android/i.test(userAgent)) {
      deviceType = 'android';
    } else if (/iphone|ipad|ipod/i.test(userAgent)) {
      deviceType = 'ios';
    } else {
      deviceType = 'other-mobile';
    }
  }

  return {
    isMobile: isMobile,
    isAndroid: deviceType === 'android',
    isiOS: deviceType === 'ios',
    deviceType: deviceType,
  };
}
export { toQueryString, detectDevice };
